module.exports = __webpack_public_path__ + "media/images/mprarchive-537783067f42f37dba6f5a9b232412bf.svg";